import { useQuery } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { FleetInventoryResponse } from './device-inventory.types';

const KEY = ['device-inventory'] as const;

/** One site's auto-discovered device inventory (fleet view). `siteId` rides in the
 *  path — a cloud-gateway call, not site-proxied. Fetch is gated until a site is set;
 *  polls on the same 30s cadence as the fleet overview. */
export function useFleetInventory(siteId: string) {
  return useQuery({
    queryKey: [...KEY, siteId],
    queryFn: () => api.get<FleetInventoryResponse>(`/users/v1/device-inventory/${siteId}`),
    enabled: Boolean(siteId),
    refetchInterval: 30_000,
  });
}
